import React from 'react'

function GlobalTitle({ topText, titleText, coloredText, classes, topTextClass }) {
    return (
        <h2 className={`group flex flex-col font-serif font-black text-3xl leading-10 md:text-4xl md:leading-12 mb-6 capitalize ${classes}`} >
            {topText && (
                <span className={`flex items-center gap-2 my-4 text-primary ${topTextClass}`}>
                    <svg width="24" height="6" viewBox="0 0 24 6" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path d="M23.5 5C23.7761 5 24 5.22386 24 5.5C24 5.77614 23.7761 6 23.5 6L8.5 6C8.22386 6 8 5.77614 8 5.5C8 5.22386 8.22386 5 8.5 5L23.5 5Z" />
                        <path d="M23.5 2.05443e-06C23.7761 2.07858e-06 24 0.22386 24 0.500002C24 0.776144 23.7761 1 23.5 1L0.5 1C0.223858 1 -6.78525e-08 0.776142 -4.37114e-08 0.5C-1.95703e-08 0.223858 0.223858 1.95703e-08 0.5 4.37114e-08L23.5 2.05443e-06Z" />
                    </svg> <span className={`block font-sans font-medium text-xs tracking-widest uppercase text-secondary group-[.text-white]:text-accent`}>{topText}</span>
                </span>
            )}
            <>
                {titleText}{" "}
                <em className="text-grad-red not-italic">
                    {coloredText}
                </em>
            </>
        </h2>
    )
}

export default GlobalTitle;